<template>
    <v-expansion-panels accordion flat>
        <v-expansion-panel>
            <v-expansion-panel-header v-slot="{open}" class="pa-0">
                <div class="v-label theme--light mb-2">
                    <label :class="{'primary--text' : open}">{{label}} ({{params.length}} {{$translate('pcs')}})</label>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div v-for="(param,idx) in params" :key="idx" class="d-flex">
                    <v-row dense>
                        <v-col cols=5><v-text-field :label="$translate('Parameter')" @input="emitValue" v-model="param.id" /></v-col>
                        <v-col cols=5><v-select :label="$translate('Setting')" :items="props" v-model="param.prop" item-value="name" :item-text="item => $translate(item.title)" @input="emitValue" /></v-col>
                        <v-col cols=2>
                        <v-btn 
                            @click="remove(param)"
                            color="error"
                            fab
                            small
                        >
                            <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <div class="d-flex">
                    <v-row dense>
                        <v-col cols=5><v-text-field :label="$translate('Parameter')" v-model="newParam.id" /></v-col>
                        <v-col cols=5><v-select :label="$translate('Setting')" :items="propsExceptUsed" v-model="newParam.prop" item-value="name" :item-text="item => $translate(item.title)" /></v-col>
                        <v-col cols=2>
                            <v-btn 
                                :disabled="!newParam.id || !newParam.prop"
                                @click="add"
                                color="success"
                                fab
                                small
                            >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: 'zoezi-page-params-setting',

    props: ['label', 'value', 'props'],

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.params = (value || []).concat();
            }
        }
    },

    computed: {
        propsExceptUsed() {
            return this.props.filter(p => !this.params.find(param => param.prop == p.name));
        }
    },

    data: () => ({
        params: [],
        newParam: {
            id: '',
            prop: null
        }
    }),

    methods: {
        emitValue() {
            this.$emit('input', this.params.map(x => ({id: x.id, prop: x.prop})));
        },
        add() {
            this.params.push({id: this.newParam.id, prop: this.newParam.prop});
            this.newParam.id = '';
            this.newParam.prop = null;
            this.emitValue();
        },
        remove(param) {
            let idx = this.params.indexOf(param);
            this.params.splice(idx, 1);
            this.emitValue();
        }
    }
}
</script>